// src/stone/icons/DollarOff.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var DollarOff = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M12 3a1 1 0 0 1 1 1v16a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1" }),
      /* @__PURE__ */ jsx("path", { d: "M1.293 1.293a1 1 0 0 1 1.414 0l20 20a1 1 0 1 1-1.414 1.414l-20-20a1 1 0 0 1 0-1.414" }),
      /* @__PURE__ */ jsx("path", { d: "M7.952 7.05A3.26 3.26 0 0 1 10.333 6h5a1 1 0 1 1 0 2h-5c-.33 0-.662.14-.919.415A1.6 1.6 0 0 0 9 9.5c0 .42.156.809.414 1.085.257.275.589.415.92.415h3.333c.907 0 1.762.387 2.38 1.05.617.66.953 1.543.953 2.45s-.336 1.79-.952 2.45A3.26 3.26 0 0 1 13.667 18H8a1 1 0 1 1 0-2h5.667c.33 0 .662-.14.918-.415.259-.276.415-.666.415-1.085 0-.42-.156-.809-.415-1.085a1.26 1.26 0 0 0-.918-.415h-3.334a3.26 3.26 0 0 1-2.38-1.05A3.6 3.6 0 0 1 7 9.5c0-.907.336-1.79.952-2.45" }),
      /* @__PURE__ */ jsx("path", { d: "M12 2a9.95 9.95 0 0 0-5.044 1.363 1 1 0 1 1-1.01-1.726A11.95 11.95 0 0 1 12 0c6.627 0 12 5.373 12 12a11.95 11.95 0 0 1-1.606 6 1 1 0 1 1-1.731-1A9.95 9.95 0 0 0 22 12c0-5.523-4.477-10-10-10M2.972 5.634a1 1 0 0 1 .365 1.367A9.95 9.95 0 0 0 2 12c0 5.523 4.477 10 10 10a9.95 9.95 0 0 0 5-1.337 1 1 0 1 1 1 1.731A11.95 11.95 0 0 1 12 24C5.373 24 0 18.627 0 12c0-2.184.584-4.235 1.606-6a1 1 0 0 1 1.366-.366" })
    ]
  }
);
var DollarOff_default = DollarOff;

export {
  DollarOff_default
};
